// extracted by mini-css-extract-plugin
export default {"tabNavWithHeader":"_2XsjI3uKyUcS-_f8v63BzM","extraTabNavWithImageStyles":"Jpv1jVgvigGh2jBMLmFYW","active":"_1uSTQDQgwky7gtbcgMF3Di"};